import React from 'react';

const Loading = ({ size = 'medium', text = 'Yükleniyor...' }) => {
    const sizeClass = {
        small: 'loading-small',
        medium: 'loading-medium',
        large: 'loading-large'
    }[size];

    return (
        <div className={`loading-container ${sizeClass}`}>
            <div className="loading-spinner">
                <div className="spinner"></div>
            </div>
            {text && <p className="loading-text">{text}</p>}
        </div>
    );
};

export default Loading;
